import React from "react";

import logo from "./assets/logo.png";

function Logo({ className, width, alt }) {
  return (
    <img
      src={logo}
      className={className}
      width={width || "100%"}
      alt={alt || "KbPort logo"}
    />
  );
}

export default Logo;
